//   getTaskSession({ id: 3423, taskType: 'single', clientId: 3424, taskId: 155 }).unwrap();
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { convertToMomentDate, successMessageToast, userFullName } from "helpers/common";
import React, { useEffect, useMemo, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, useLocation, useParams } from "react-router-dom";
import { useGetTaskSessionStaffMutation, useSaveSingleStaffTaskMutation, useStaffClientAttendanceUpdateMutation, useSubmitSingleStaffTaskMutation } from "store/services/staff";
import Switch from "react-switch";
import ViewAttachments from "./ViewAttachments";
import { useLazyGetFileUrlQuery } from "store/services/utility";
import SessionOutcomePieChart from "components/shared/ReportComponents/SessionOutcomePieChart";
import { GOAL_TRACK_PARAMETERS, GOAL_TRACK_PARAMETERS_STAFF, MIME_TYPES } from "config/constants";
import { getGoalTrackingPercentage } from "helpers/assessment";
import TrackerRangeSlider from "components/shared/ReportComponents/TrackerRangeSlider/Index";
import { MANAGE_STAFF } from "config/paths";
import { NoRecordFound } from "components/Common/Common";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { Form, Formik } from "formik";
import AppInputField from "components/shared/FormComponents/AppInputField";
import AppFileUploadField from "components/shared/FormComponents/AppFileUploadField";
import LoadingButton from "components/shared/LoadingButton";
import { isEmpty } from "lodash";
import GoalTrackingSingleForm from "./GoalTrackingSIngle";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import NotesComponent from "components/shared/FormComponents/NotesComponent";
import { useGetNoteQuery } from "store/services/note";
import moment from "moment";

// import AnswerTracker from "components/shared/ReportComponents/AnswerFields/AnswerTracker";

const StartSessionStaff = () => {
  const { taskId, clientId, staffId, taskType } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const task_datetime = queryParams.get('task_datetime');
  const [checked, setChecked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [formValues, setFormValues] = useState(null);


  const [getTaskSessionStaff, { data, isLoading, isError }] = useGetTaskSessionStaffMutation();
  const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();
  const [updateAttendance, { isLoading: updateAttendanceLoading }] = useStaffClientAttendanceUpdateMutation()
  const [submitTask, { isLoading: submitTaskLoading }] = useSubmitSingleStaffTaskMutation();
  const [saveTask, { isLoading: saveTaskLoading }] = useSaveSingleStaffTaskMutation();
  // const { data: noteDetails } = useGetNoteQuery({ clientId: taskId, moduleName: `task_occurence_${moment(task_datetime).format("YYYY-MM-DD")}` });
  const { data: noteDetails } = useGetNoteQuery({ clientId: taskId, moduleName: `task_occurence` });


  // Extracting data from the API response
  const taskData = data?.data;
  const associatedTasks = taskData?.associatedTasks;
  const associatedMapping = taskData?.associatedMapping;
  const associatedClient = taskData?.associatedClient;
  // const taskProgress = taskData?.associatedTaskProgress ?? associatedMapping ;
  const taskProgress =
  data?.data?.associatedTaskProgress
  ? data?.data?.associatedTaskProgress
  : data?.data?.associatedMapping && data?.data?.associatedTasks?.duration === "no_repeat"
  ? data.data?.associatedMapping
  : data?.data?.associatedTaskProgress;
  const previewMode = ["submitted", "completed"]?.includes(taskProgress?.status)
  const trackerType = taskData?.associatedTasks?.tracker_type;

  const therapist = associatedTasks?.owner;

  // Safely parse task_data if it exists
  let trackerData = {};
  try {
    trackerData = taskProgress?.task_data ? JSON.parse(taskProgress.task_data) : {};
  } catch (error) {
    console.error("Error parsing task_data:", error);
  }

  const initialValues = useMemo(() => {
    const output = {
      answer: trackerData?.answer || "",
      files: trackerData?.files
    }

    if (trackerType === "discrete") {
      output.goalTracking = !isEmpty(trackerData?.goalTracking) ? trackerData?.goalTracking : [{}];
    } else if (trackerType === "frequency") {
      output.tracker = !isEmpty(trackerData?.tracker) ? trackerData?.tracker : {};
    }

    return output;
  }, [taskProgress]);

  const fetchData = async () => {
    const payload = { task_datetime };
    try {
      // const response = await getTaskSession({ id: 3423, taskType: 'single', clientId: 3424, taskId: 155 }).unwrap();
      const response = await getTaskSessionStaff({ id: clientId, taskType: 'single', clientId: staffId, taskId: taskId, payload: payload }).unwrap();

      if (response.status === "failure") {
        setErrorMessage(response.message);
      }
    } catch (err) {
      console.error("Error getting progress data", err);
      setErrorMessage("An unexpected error occurred. Please try again later.");
    }
  };

  const handleViewPdf = async (name) => {

    try {
      const url = await getFileUrl(name).unwrap();
      if (url) window.open(url, '_blank');

    } catch (err) { console.error("Error assigning therapist", err); }
  };

  // const handleAttendace = async (attendance) => {
  //   try {
  //     const result = await updateAttendance({ id: associatedMapping?.id, attendance }).unwrap()
  //     fetchData();
  //     successMessageToast(result?.message)
  //   } catch (error) {
  //     console.log('error updating attendance: ', error)
  //   }
  // }

  const handleAttachDocument = (name, value, prevValues, setFieldValue) => {
    try {
      let cloneValues = prevValues ? cloneDeep(prevValues) : [];
      cloneValues.push({
        attachment_key: value,
        attachment_name: value,
      })
      setFieldValue(name, cloneValues);
    } catch (err) {
      console.error("Failed to attach document", err);
    }
  };

  const handleSubmit = (values) => {
    setFormValues(values);
    setShowModal(true);
  };

  const confirmHandleSubmit = async () => {
    setShowModal(false)
    try {
      const payload = {
        taskId,
        clientId,
        staffId,
        data: {
          // task_data: values,
          task_data: formValues,
          task_datetime: task_datetime,
          attendance: checked
        }
      }

      // console.log("payload------------->",payload)
      // console.log("formValues------------->",formValues)
      await submitTask(payload).unwrap();
      successMessageToast("Task submitted!");
      fetchData();
    } catch (err) {
      console.error("Error submitting task", err);
    }
  }

  const handleSaveProgress = async (values) => {
    try {
      const payload = {
        taskId,
        clientId,
        staffId,
        data: {
          // task_data: values,
          task_data: values,
          task_datetime: task_datetime,
          attendance: checked
        }
      }

      // console.log("payload------------->",payload)
      // console.log("formValues------------->",formValues, payload)
      await saveTask(payload).unwrap();
      successMessageToast("Task Saved!");
      fetchData();
    } catch (err) {
      console.error("Error submitting task", err);
    }
  }

  useEffect(() => {
    fetchData();
  }, [task_datetime, taskId, clientId, staffId, taskType, getTaskSessionStaff]);

  useEffect(() => {
    setChecked(associatedMapping?.attendance == "present" ? "present" : "absent")
  }, [associatedMapping])

  return (
    <>
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        type={"tasksumbit"}
        confirmHandler={confirmHandleSubmit}
      />
      <section className='mt-3 border-bottom'>
        <Container fluid>
          <Row className='justify-content-between align-items-center'>
            <Col lg='6'>
              <p className='mb-0'>
                <Link to={MANAGE_STAFF} className="themeClr">Support Staff</Link>
                {" "}/{" "}
                <span className='mb-0' style={{ fontWeight: "600" }}>View Session</span>
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {isLoading ? (
        <LoadingOverlay />
      ) : isError || errorMessage ? (
        <ErrorComponent message={errorMessage || "An error occurred while fetching data."} />
      ) : (


        <section>
          {
            updateAttendanceLoading && <LoadingOverlay />
          }
          <section className='mt-4'>
            <Container fluid>
              <Row>
                <Col lg='6'>
                  <Row>
                    <Col md="6" sm="6" className='my-2'>
                      <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                        <h6 className="m-0 themeBlue fw-bold">
                          <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                          Task Title
                        </h6>
                        <p className="m-0 themeBlue pt-2">
                          {data?.data?.associatedTasks?.task_title}
                        </p>
                      </div>
                    </Col>
                    <Col md="6" sm="6" className='my-2'>
                      <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                        <h6 className="m-0 themeBlue fw-bold">
                          <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                          Name of Discipline
                        </h6>
                        <p className="m-0 themeBlue pt-2">
                          {therapist?.therapist_detail?.therapist_discipline?.name}
                        </p>
                      </div>
                    </Col>
                    <Col md="6" sm="6" className='my-2'>
                      <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                        <h6 className="m-0 themeBlue fw-bold">
                          <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                          Client Name
                        </h6>
                        <p className="m-0 themeBlue pt-2">
                          {userFullName(associatedClient)}
                        </p>
                      </div>
                    </Col>
                    <Col md="6" sm="6" className='my-2'>
                      <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                        <h6 className="m-0 themeBlue fw-bold">
                          <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                          Attendance
                        </h6>
                        <div className="mt-2 d-flex align-items-center">
                          <span>Absent</span>
                          <Switch
                            className="mx-2"
                            uncheckedIcon={""}
                            checkedIcon={""}
                            onHandleColor={"#A3DF00"}
                            offHandleColor={"#A3DF00"}
                            onColor={"#E6E6E6"}
                            offColor={"#E6E6E6"}
                            height={18}
                            width={40}
                            // checked={attendanceStatus === "Present"}
                            // onChange={() => handleAttendace(attendanceStatus === "Present" ? "absent" : "present")}
                            checked={checked == "present"}
                            onChange={() => setChecked((prev) => prev == "present" ? "absent" : "present")}
                            disabled={previewMode}
                          />
                          <span>Present</span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col lg='6'>
                  <Row className='justify-content-end pe-2 align-items-start'>
                    <Col lg="4" className='my-2'>
                      <div className="cardCstm p-3 bg-white shadow h-100 rounded border-bottom">
                        <h6 className="m-0 themeBlue fw-bold">
                          <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                          Target Date
                        </h6>
                        <div className='d-flex pt-2 align-items-center'>
                          <p className="m-0 themeBlue ms-1">
                            {convertToMomentDate(taskData?.createdAt)}
                          </p>
                        </div>
                      </div>
                      {/* <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                        <h6 className="m-0 themeBlue fw-bold">
                          <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                          End Date
                        </h6>
                        <div className='d-flex pt-2 align-items-center'>
                          <p className="m-0 themeBlue ms-1">
                            {convertToMomentDate(associatedTasks?.ends_on_data?.endDate)}
                          </p>
                        </div>
                      </div> */}
                    </Col>
                  </Row>
                </Col>

                <Col md="12" sm="6" className='my-2'>
                  <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                    <h6 className="m-0 themeBlue fw-bold">
                      <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                      Description
                    </h6>
                    <p className="m-0 themeBlue pt-2">
                      {associatedTasks?.description || "--"}
                    </p>
                  </div>
                </Col>
                <Col lg="6" sm="12" className="my-3">
                  {/* <h6 className="m-0 themeBlue fw-sbold">Notes</h6> */}
                  <NotesComponent
                    // heading="Clinician's Instructions"
                    buttonName="Create"
                    notes={noteDetails}
                    className={`form-control`}
                    module={`task_occurence`}
                    // module={`task_occurence_${moment(task_datetime).format("YYYY-MM-DD")}`}
                    client_id={taskId}
                  />
                </Col>
              </Row>
            </Container>
          </section>

          <section className='mt-4'>
            <Container fluid>
              <Row>
                <Col lg="12">
                  <div className='px-2 py-3 rounded' style={{ backgroundColor: "#B46C9F1F" }}>
                    <p className='mb-0' style={{ color: "#071E3E" }}>
                      <span className='px-2 py-2 rounded me-3' style={{ backgroundColor: "#B46C9F33", color: "#82777f", fontWeight: "700" }}>Clinician's instructions</span>
                      {associatedTasks?.clinical_instruction || "--"}
                    </p>
                  </div>
                </Col>

                <Col lg="6">
                  <ViewAttachments
                    attachments={taskData?.documents}
                    handleViewPdf={handleViewPdf}
                    title={"Documents :"}
                  />
                </Col>
                <Col lg="6">
                  <ViewAttachments
                    attachments={taskData?.resources}
                    handleViewPdf={handleViewPdf}
                    title={"Resources :"}
                  />
                </Col>
              </Row>
            </Container>
          </section>


          {/* {
            data?.data?.associatedTaskProgress || (data?.data?.associatedMapping && data?.data?.associatedTasks?.duration == "no_repeat") ?
              <section className='my-4'>
                <Container fluid>
                  <Row>
                    <Col lg="6">
                      {
                        trackerData?.tracker?.percentage &&
                        <div>
                          <label className="fw-semibold my-3">Tracker</label>
                          <div className="py-2">
                            <div className="position-relative">
                              <div className="d-flex align-items-start flex-column justify-content-between gap-10 w-100">
                                <TrackerRangeSlider
                                  labels={['Infrequent', 'Frequent']}
                                  value={trackerData?.tracker?.percentage || 0}
                                >
                                  <input
                                    value={trackerData?.tracker?.percentage || 0}
                                    id="frequency-range"
                                    className="frequency-range"
                                    type={"range"}
                                    min="0"
                                    max="100"
                                    disabled={true}
                                  />
                                </TrackerRangeSlider>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      <div>
                        <div className="py-2">
                          <div className="position-relative">
                            <label className="fw-semibold my-3">Description</label>
                            <p className="form-control rounded-3 bg-white h-auto" rows={5}>
                              {trackerData?.answer || "No answer provided"}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="py-2">
                        <div className="position-relative">
                          <ul className="list-unstyled">
                            <ViewAttachments
                              attachments={trackerData.files}
                              handleViewPdf={handleViewPdf}
                              title={"Attachments:"}
                            />
                          </ul>
                        </div>
                      </div>
                    </Col>
                    {
                      trackerData?.goalTracking &&
                      <Col lg="6" className="my-2">
                        <div className="cardCstm rounded-3" style={{ background: "#F7F0F5" }}>
                          <div className="top p-3 border-bottom">
                            <h6 style={{ fontSize: 14 }} className="m-0 fw-bold text-uppercase">
                              Session Outcomes
                            </h6>
                          </div>
                          <div className="contentBody p-3">
                            <Row>
                              <Col lg="5" className="my-2">
                                <SessionOutcomePieChart
                                  trackingData={
                                    trackerData?.goalTracking
                                  }
                                />
                              </Col>
                              <Col lg="7" className="my-2">
                                {trackerData?.goalTracking?.length > 0 ? (
                                  <ul className="list-unstyled ps-0 mb-0">
                                    {Object.entries(GOAL_TRACK_PARAMETERS_STAFF)?.map(([param, label], index) => {
                                      let parameterPercentage = getGoalTrackingPercentage(param, trackerData?.goalTracking);
                                      return (
                                        <li
                                          key={index}
                                          className="py-1 d-flex align-items-center justify-content-between gap-10"
                                        >
                                          <p className="m-0">
                                            <span className="fw-sbold">
                                              {param}
                                            </span>{" "}
                                            -{label}
                                          </p>
                                          <p className="m-0 fw-bold">
                                            <span className="px-2">
                                              {
                                                parameterPercentage
                                              }
                                            </span>
                                            %
                                          </p>
                                        </li>
                                      );
                                    }
                                    )}
                                  </ul>
                                ) : (
                                  <p>
                                    Goal not tracked yet
                                  </p>
                                )}
                              </Col>
                            </Row>
                          </div>
                          <div className="contentBody p-3">
                      <Row>
                        <Col lg="7" className="my-2">
                          <p>Tracker Percentage: {trackerData?.tracker?.percentage || 0}%</p>
                        </Col>
                      </Row>
                    </div>
                        </div>
                      </Col>
                    }
                  </Row>
                </Container>
              </section>
              : <section className='my-4'>  <div className={`py-2 d-flex align-items-center justify-content-center w-100 `}>
                Support staff has not submitted the required data yet.
              </div></section>
          } */}
          <section className='my-4'>
            <Formik
              // innerRef={formikRef}
              initialValues={initialValues}
              // validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({
                values,
                errors,
                setFieldValue,
                handleSubmit
              }) => {
                return (
                  <Form onSubmit={handleSubmit}>
                    {console.log({ values, errors })}
                    <Container fluid>
                      <Row>
                        <Col lg="6">
                          {trackerType !== "none" && (
                            <label className="fw-semibold my-3">Tracker</label>
                          )}
                          {trackerType === "discrete" ? (
                            <GoalTrackingSingleForm disabled={previewMode} />
                          ) : trackerType === "frequency" ? (
                            <div className="d-flex align-items-start flex-column justify-content-between gap-10 w-100">
                              <TrackerRangeSlider
                                value={values?.tracker?.percentage || 0}
                              >
                                <AppInputField
                                  id="frequency-range"
                                  className="frequency-range"
                                  name={`tracker.percentage`}
                                  type={"range"}
                                  min="0"
                                  max="100"
                                  disabled={previewMode}
                                />
                              </TrackerRangeSlider>
                            </div>
                          ) : (
                            null
                          )}
                          <div className="py-2">
                            {previewMode && <label className="fw-semibold my-3">Description</label>}
                            <div className="position-relative">
                              <AppInputField
                                name="answer"
                                fieldType={"textarea"}
                                className="form-control rounded-3 bg-white h-auto"
                                rows={5}
                                placeholder="Add information on what types of activities were used to elicit the goal"
                                disabled={previewMode}
                              />
                            </div>
                          </div>
                        </Col>
                        {trackerType === "discrete" && (
                          <Col lg="6" className="my-2">
                            <div
                              className="cardCstm rounded-3"
                              style={{ background: "#F7F0F5" }}
                            >
                              <div className="top p-3 border-bottom">
                                <h6
                                  style={{ fontSize: 14 }}
                                  className="m-0 fw-bold text-uppercase"
                                >
                                  Session Outcomes
                                </h6>
                              </div>
                              <div className="contentBody p-3">
                                <Row>
                                  <Col lg="5" className="my-2">
                                    <SessionOutcomePieChart
                                      trackingData={
                                        values?.goalTracking
                                      }
                                    />
                                  </Col>
                                  <Col lg="7" className="my-2">
                                    {values?.goalTracking?.length > 0 ? (
                                      <ul className="list-unstyled ps-0 mb-0">
                                        {Object.entries(GOAL_TRACK_PARAMETERS_STAFF)?.map(([param, label], index) => {
                                          let parameterPercentage = getGoalTrackingPercentage(param, values?.goalTracking);
                                          return (
                                            <li
                                              key={index}
                                              className="py-1 d-flex align-items-center justify-content-between gap-10"
                                            >
                                              <p className="m-0">
                                                <span className="fw-sbold">
                                                  {param}
                                                </span>{" "}
                                                -{label}
                                              </p>
                                              <p className="m-0 fw-bold">
                                                <span className="px-2">
                                                  {
                                                    parameterPercentage
                                                  }
                                                </span>
                                                %
                                              </p>
                                            </li>
                                          );
                                        }
                                        )}
                                      </ul>
                                    ) : (
                                      <p>
                                        Goal not tracked yet
                                      </p>
                                    )}
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        )}
                      </Row>
                      {
                        !previewMode &&
                        <div className='mt-5' style={{ display: "inline-block" }}>
                          {/* <button type="button" onClick={handleuload} className='py-3 px-5 m-0 border-0 text-white rounded' style={{ background: "#3DA0AA" }}>
                          <img className='me-1' src={Images.attach_file_add} alt="attach_file_add" />
                          Attach Document
                        </button> */}

                          <AppFileUploadField
                            name="files"
                            acl={"private"}
                            accept="image/*, application/pdf, .doc, .docx"
                            allowedTypes={[MIME_TYPES.pdf, MIME_TYPES.png, MIME_TYPES.jpeg, MIME_TYPES.jpg, MIME_TYPES.webp, MIME_TYPES.doc, MIME_TYPES.docx]}
                            // className={`${styles.formControl} form-control`}
                            className={`form-control`}
                            disabled={previewMode}
                            onChange={(name, value) => {
                              handleAttachDocument(name, value, values?.documents, setFieldValue);
                            }}
                          />
                        </div>
                      }
                      {
                        values?.files?.length > 0 &&
                        <Row>
                          <Col lg="6">
                            <ViewAttachments
                              attachments={values?.files}
                              handleViewPdf={handleViewPdf}
                            // title={"Resources :"}
                            />
                          </Col>
                        </Row>
                      }
                      <div className='mt-5 d-flex gap-10' >
                        <LoadingButton
                          className='border-0 commonBtn'
                          style={{ background: "#3DA0AA" }}
                          onClick={() => { handleSaveProgress(values); }}
                          isLoading={saveTaskLoading}
                          disabled={previewMode || saveTaskLoading || submitTaskLoading}
                          type="button"
                        >
                          Save For Later
                        </LoadingButton>
                        <LoadingButton
                          className='commonBtn'
                          // style={{ background: "#3DA0AA" }}
                          type="submit"
                          isLoading={submitTaskLoading}
                          disabled={previewMode || submitTaskLoading || saveTaskLoading}
                        >
                          Submit
                        </LoadingButton>
                      </div>
                    </Container>
                  </Form>
                )
              }}
            </Formik>
          </section>
        </section>
      )}


    </>
  );
};

export default StartSessionStaff;